import React from 'react'
import ActionButton from 'microcosm/addons/action-button'
import cx from 'classnames'
import RA from 'ra-config'
import Match from 'lib/components/match'
import Icon from 'lib/components/icon'
import Tooltip from 'lib/components/tooltip'
import { coreSiteUrl, interactiveSiteUrl } from 'lib/config/url'
import { replace } from 'lib/config/placeholder'

export default function Footer({
  className,
  downloadAction,
  printAction,
  LoginTrap
}) {
  const classes = cx('footer', className)
  const {
    featureContentLeft,
    featureContentRight,
    shareTitle,
    shareText
  } = RA.content
  const { resourcesTitle, resourcesPath, legalTitle, legalPath } = RA.app.page

  return (
    <footer className={classes}>
      {featureContentLeft && <FeatureItem content={featureContentLeft} />}

      {featureContentRight && <FeatureItem content={featureContentRight} />}

      <div className="spacer" />

      <Match min="medium-min">
        {printAction && <PrintItem action={printAction} />}
      </Match>

      <Match min="tablet-min">
        {downloadAction && <DownloadItem action={downloadAction} />}
      </Match>

      <Match min="tablet-min">
        <ShareItem title={shareTitle} text={shareText} />
      </Match>

      {resourcesTitle && resourcesPath && (
        <LinkItem
          title={resourcesTitle}
          path={resourcesPath}
          resolveUrl={interactiveSiteUrl}
        />
      )}

      <LinkItem title={legalTitle} path={legalPath} resolveUrl={coreSiteUrl} />

      {LoginTrap && <LoginTrap />}
    </footer>
  )
}

function LinkItem({ title, path, resolveUrl }) {
  return (
    <a className="link__item" href={resolveUrl(path)} target="_blank">
      <span className="type-subtitle">{title}</span>
    </a>
  )
}

function FeatureItem({ content }) {
  const { path, label, text } = content
  return (
    <a className="feature__item" href={replace(path)} target="_blank">
      <span>
        {getFeatureIcon(content)}
        {label && <label className="type-subtitle">{label} </label>}
        <span className="type-article-title">{text}</span>
      </span>
    </a>
  )
}

function getFeatureIcon({ icon }) {
  return <Icon type={icon || 'read'} width="22px" height="22px" fill="#fff" />
}

function DownloadItem({ action }) {
  return (
    <ActionButton
      tag="a"
      target="_blank"
      action={action}
      className="download__item"
    >
      <Icon type="download" height="22px" width="22px" fill="#fff" />
      Download
    </ActionButton>
  )
}

function PrintItem({ action }) {
  return (
    <ActionButton
      tag="a"
      target="_blank"
      action={action}
      className="download__item"
    >
      <Icon type="print" height="22px" width="22px" fill="#fff" />
      Print
    </ActionButton>
  )
}

function ShareItem({ title, text }) {
  return (
    <Tooltip
      className="share__item"
      onOpen={onShareOpen}
      overlay={getShareTooltipContent(text)}
    >
      <Icon type="share" height="22px" width="22px" fill="#fff" />
      <span className="type-subtitle">{title}</span>
    </Tooltip>
  )
}

function getShareTooltipContent(text) {
  return (
    <div className="share__item__tooltip">
      <span dangerouslySetInnerHTML={{ __html: text }} />
      <input type="text" value={window.location} readOnly={true} />
    </div>
  )
}

function onShareOpen(popupDomNode) {
  var input = popupDomNode.getElementsByTagName('input')
  if (input.length > 0) {
    input[0].select()
    input[0].focus()
  }
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/footer/index.js